export type Employee = {
  employee_id: string;
  employee_name: string;
  employee_image: string;
  employee_mail: string;
  department: string;
  designation: string;
  total_time: string;
  productive_time: string;
  productive_percentage: string;
  unproductive_time: string;
  unproductive_percentage: string;
};

export function sortData(
  data: Employee[],
  field: keyof Employee,
  order: string = "asc"
): Employee[] {
  return [...data].sort((a, b) => {
    const valA = a[field];
    const valB = b[field];

    // Convert numeric strings to numbers
    const numA = Number(valA);
    const numB = Number(valB);

    const isNumberA = !isNaN(numA);
    const isNumberB = !isNaN(numB);

    if (isNumberA && isNumberB) {
      return order === "asc" ? numA - numB : numB - numA;
    }

    // String comparison (case-insensitive)
    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();

    return order === "asc"
      ? strA.localeCompare(strB)
      : strB.localeCompare(strA);
  });
}
